import {FileLikeObject} from 'ng2-file-upload';
import {BusinessContextPayload} from '../../../../common/businesscontext/api/payload/businessContext.payload';

export class MessageCreatePayload {
    content: string;
    attachments: FileLikeObject[] = [];
}
